module.exports = __webpack_public_path__ + "media/images/people/boy-2-c7d6843a9b52558dcaf1a0973456fe22.webp";